exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".middle[data-v-c30badc4]{color:#515152;padding:4px}.address-title[data-v-c30badc4]{font-size:14px}.address-text[data-v-c30badc4]{font-size:12px;color:#515152}.address-list[data-v-c30badc4]:hover{background:rgba(9,167,149,.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c30badc4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AddressCard.vue
// module id = x/u3
// module chunks = 0